module.exports = __webpack_public_path__ + "static/media/AzizUrRehman.806b23b0.jpeg";